import { FC } from 'react';

import { clsx } from 'clsx';

import { CartonProduct, OverviewProduct } from '../../types';
import { Badge } from '../ui/Badge';

interface Props {
    product: CartonProduct | OverviewProduct;
    className?: string;
    showUniverseBadge?: boolean;
    hideSecondaryBadgesOnMobile?: boolean;
    hideSecondaryBadgesUntil?: 'sm' | 'md' | 'lg';
}

export const ProductCardBadges: FC<Props> = ({
    product,
    className,
    showUniverseBadge = false,
    hideSecondaryBadgesOnMobile = false,
    hideSecondaryBadgesUntil,
}) => {
    const secondaryBadges = product.secondary_badges ?? [];
    const secondaryBadgeVisibilityClass =
        hideSecondaryBadgesUntil === 'lg'
            ? 'hidden lg:inline-flex'
            : hideSecondaryBadgesUntil === 'md'
              ? 'hidden md:inline-flex'
              : (hideSecondaryBadgesUntil === 'sm' ||
                    hideSecondaryBadgesOnMobile) &&
                'hidden sm:inline-flex';

    if (
        !product.expansion_tag &&
        secondaryBadges.length === 0 &&
        (!showUniverseBadge || !product.universe_name)
    ) {
        return null;
    }

    return (
        <div className={clsx('flex flex-wrap items-end gap-1.5', className)}>
            {showUniverseBadge && product.universe_name && (
                <Badge
                    variant="neutral"
                    className="max-w-full truncate text-xs"
                >
                    {product.universe_name}
                </Badge>
            )}
            {product.expansion_tag && (
                <Badge
                    className="text-xs"
                    data-testid="product-card-primary-badge"
                >
                    {product.expansion_tag}
                </Badge>
            )}
            {secondaryBadges.map((badge, index) => (
                <Badge
                    key={`${badge.key}-${badge.value}-${index}`}
                    variant="outline"
                    className={clsx('text-xs', secondaryBadgeVisibilityClass)}
                    data-testid="product-card-secondary-badge"
                >
                    {badge.value}
                </Badge>
            ))}
        </div>
    );
};
